export default function monkeyPatch(instanceToPatch, literalWithMethods) {
    Object.keys(literalWithMethods).forEach(key=> {
        if (typeof instanceToPatch[key]==='undefined') {
            instanceToPatch[key] = literalWithMethods[key];
        }
    });
}
